import { useEffect, useState } from "react";
import {
  SCButton,
  SCDialog,
  SCInputText,
  SCRadioButton,
  SCCheckbox,
  SCAutoComplete,
} from "../../components";
import { SiMicrosoftexcel } from "react-icons/si";
import { SlPrinter } from "react-icons/sl";
import TooltipOptions from "primereact/tooltip/tooltipoptions";
import { Divider } from "primereact/divider";
import api from "../../services/api";
import { downloadExcel } from "react-export-table-to-excel";
import { useAuth } from "../../providers/auth";
import { useToast } from "../../context/ToastContext";
import { FormProvider, useForm } from "react-hook-form";
import LoadingReport from "../../components/LoadingReport";
import { Fieldset } from "primereact/fieldset";
import Loading from "../../components/Loading";
import IFiltroTurmaRegular from "../../interfaces/IFiltroTurmaRegular";
import SelectCurso from "../../components/SelectCurso";
import buildTurmasRegulares from "../../templates/relacao_turmas_regulares";
import { IContasAPagarRelatorioFiltros } from "../../interfaces/IContasAPagar";
import SelectColaborador from "../../components/SelectColaborador";
import SelectCredor from "../../components/SelectCredor";
import SelectCentroCusto from "../../components/SelectCentroCusto";
import SCCalendar from "../../components/form/calendar/SCCalendar";
import SelectContaSaida from "../../components/SelectContaSaida";
import SelectFonte from "../../components/SelectFonte";
import SelectFormaPagamento from "../../components/SelectFormaPagamento";

interface Props {}

const Relatorio_ContasAPagar = () => {
  const toast = useToast();
  const [tipo, setTipo] = useState("Resumido");

  const { usuario, empresaSelecionada, periodoSelecionado } = useAuth();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState<any>(null);
  const [loadReport, setLoadReport] = useState(false);
  const [gradesTurmas, setGradesTurmas] = useState<any>([]);

  const defaultValues: IContasAPagarRelatorioFiltros = {
    printType: "E",
    empresaId: empresaSelecionada?.EmpresaId || null,
    operador: null,
    creditor: "",
    account: "",
    costCenter: "",
    source: "",
    pageFormat: "",
    docNumber: "",
    pageOptions: "pages",
    pagesPerDay: false,
    overduePages: false,
    payTomorrow: false,
    payOverdue: false,
    considerExpenses: false,
    showOnlyFiesRecords: false,
    title: "",
    classifiedBy: "dataPagto",
    classification: "conta",
  };

  const methods = useForm({ defaultValues });
  const {
    handleSubmit,
    control,
    formState: { errors },
    getValues,
    setValue,
  } = methods;

  const tooltipOptions: TooltipOptions = {
    position: "top",
  };

  const initialLoad = async () => {
    setLoading(true);
    try {
      const { data: gradesTurmas } = await api.get(
        "/report/funcionarios/relacao",
        {
          params: {
            empresaId: empresaSelecionada?.EmpresaId || null,
            ano: periodoSelecionado?.Ano || new Date().getFullYear().toString(),
            sequencial: periodoSelecionado?.Sequencial || "1",
          },
        }
      );
    } catch (error) {
      console.error("Error fetching courses:", error);
      toast.showToast({
        severity: "error",
        summary: "Erro",
        detail: "Erro ao carregar cursos",
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    initialLoad();
  }, []);

  const onExcel = async () => {
    setLoadReport(true);
    const result = await api.get("/funcionarios/list", {
      params: {},
    });
    console.log(result.data);
    downloadExcel({
      fileName: "Colaboradores",
      sheet: "Listagem",
      tablePayload: {
        header: [
          "Nome",
          "Matrícula",
          "Situação",
          "Apelido",
          "Data de Nasc.",
          "Sexo",
          "Cargo",
        ],
        body: result.data.map((item: any) => {
          return [
            item.Nome,
            item.Matricula,
            item.Ativo ? "Ativo" : "Inativo",
            item.Guerra,
            item.DataNascimento
              ? new Date(item.DataNascimento).toLocaleDateString()
              : "",
            item.Sexo == "M" ? "Masculino" : "Feminino",
            item.cargo,
          ];
        }),
      },
    });
    setLoadReport(false);
  };

  const onSubmit = async (formData: IContasAPagarRelatorioFiltros) => {
    setLoadReport(true);

    // try {
    //   const data = await getDados(formData);

    //   let report = buildTurmasRegulares(
    //     data,
    //     formData,
    //     empresaSelecionada,
    //     periodoSelecionado,
    //     usuario
    //   );
    //   console.log("data", data);

    //   const restReport = await api.post("/gerarRelatorio", report, {
    //     responseType: "blob",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Accept: "application/pdf",
    //     },
    //   });

    //   const blob = new Blob([restReport.data], { type: "application/pdf" });
    //   const url = URL.createObjectURL(blob);

    //   setReportData(url);
    // } catch (e) {
    //   console.log(e);
    //   toast.showToast({
    //     severity: "error",
    //     summary: "Erro",
    //     detail: "Erro ao gerar relatório",
    //   });
    // }

    setLoadReport(false);
  };

  const getDados = async (filtros: any) => {
    setGradesTurmas(gradesTurmas);

    const { data } = await api.get("/report/turmas/relacao", {
      params: filtros,
    });
    return data;
  };

  if (loading) return <Loading />;

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="pt-2"
        style={{ paddingBottom: 60 }}
      >
        {loadReport && <LoadingReport full={true} />}
        <div className="card">
          <div
            className="flex justify-content-center align-items-center p-2 border-round-top-md text-white"
            style={{ backgroundColor: "#0772B3" }}
          >
            <h5 className="m-0 flex flex-1 align-items-center justify-content-center">
              Relação de Contas a Pagar
            </h5>
          </div>
          <div className="p-2 border rounded-md mx-auto">
            {/* Linha 1: Imprimir */}
            <div className="grid">
              <div className="col-6">
                <label className="pr-3">Imprimir</label>
                <div
                  className="flex align-items-center justify-content-start p-2"
                  style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                >
                  <SCRadioButton
                    control={control}
                    name="printType"
                    label="Somente esta Escola"
                    value="E"
                  />
                  <SCRadioButton
                    control={control}
                    name="printType"
                    label="Global"
                    value="G"
                    className="ml-3"
                  />
                </div>
              </div>
            </div>

            {/* Linha 2: Operador */}
            <div className="grid">
              <div className="col-6">
                <SelectColaborador
                  control={control}
                  errors={errors}
                  label="Operador"
                  name="operador"
                  className="w-full"
                />
              </div>
              <div className="col-6">
                <SelectCredor
                  control={control}
                  errors={errors}
                  label="Credor"
                  name="credor"
                  className="w-full"
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-6">
                <SelectContaSaida
                  control={control}
                  errors={errors}
                  label="Conta"
                  name="conta"
                  className="w-full"
                />
              </div>

              <div className="col-6">
                <SelectCentroCusto
                  control={control}
                  errors={errors}
                  label="Centro de Custo"
                  name="centrocusto"
                  className="w-full"
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-3">
                <SelectFonte
                  control={control}
                  errors={errors}
                  label="Fonte"
                  name="fonte"
                  className="w-full"
                />
              </div>
              <div className="col-3">
                <SelectFormaPagamento
                  control={control}
                  errors={errors}
                  label="Form.Pagto."
                  name="pageFormat"
                  className="w-full"
                />
              </div>
              <div className="col-3">
                <SCInputText
                  control={control}
                  errors={errors}
                  label="Nº Doc"
                  name="docNumber"
                  className="w-full"
                />
              </div>
            </div>

            {/* Linha 6: Pagas, A Pagar, Todas */}
            <div className="grid">
              <div className="col-6">
                <label className="pr-3">Situação</label>
                <div
                  className="flex align-items-center justify-content-start p-2"
                  style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                >
                  <SCRadioButton
                    control={control}
                    name="pageOptions"
                    label="Pagas"
                    value="pages"
                  />
                  <SCRadioButton
                    control={control}
                    name="pageOptions"
                    label="A Pagar"
                    value="toPay"
                    className="ml-3"
                  />
                  <SCRadioButton
                    control={control}
                    name="pageOptions"
                    label="Todas"
                    value="all"
                    className="ml-3"
                  />
                </div>
                <div
                  className="flex align-items-center justify-content-start p-2 mt-1"
                  style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                >
                  <SCCheckbox
                    control={control}
                    name="pagesPerDay"
                    label="Pagas em dia"
                  />
                  <SCCheckbox
                    control={control}
                    name="overduePages"
                    label="Pagas vencidas"
                    className="ml-3"
                  />
                  <SCCheckbox
                    control={control}
                    name="payTomorrow"
                    label="A Pagar a vencer"
                    className="ml-3"
                  />
                  <SCCheckbox
                    control={control}
                    name="payOverdue"
                    label="A Pagar vencidas"
                    className="ml-3"
                  />
                </div>
              </div>
            </div>

            {/* Períodos */}
            <Fieldset
              legend="Períodos"
              className="mt-2"
              style={{ border: "1px solid #ccc", borderRadius: "5px" }}
            >
              <div className="grid">
                <div className="col-4">
                  <SCCalendar
                    control={control}
                    errors={errors}
                    name="launchStart"
                    label="Lançamento"
                    selectionMode="range"
                    showIcon
                    dateFormat="dd/mm/yy"
                  />
                </div>
                <div className="col-4">
                  <SCCalendar
                    control={control}
                    errors={errors}
                    name="dueStart"
                    label="Vencimento"
                    showIcon
                    selectionMode="range"
                    dateFormat="dd/mm/yy"
                  />
                </div>
                <div className="col-4">
                  <SCCalendar
                    control={control}
                    errors={errors}
                    name="programmingStart"
                    label="Programação"
                    showIcon
                    selectionMode="range"
                    dateFormat="dd/mm/yy"
                  />
                </div>
              </div>
              <div className="grid">
                <div className="col-4">
                  <SCCalendar
                    control={control}
                    errors={errors}
                    name="paymentStart"
                    label="Pagamento de"
                    showIcon
                    selectionMode="range"
                    dateFormat="dd/mm/yy"
                  />
                </div>
                <div className="col-4">
                  <SCCalendar
                    control={control}
                    errors={errors}
                    name="availableStart"
                    label="Disponível"
                    showIcon
                    selectionMode="range"
                    dateFormat="dd/mm/yy"
                  />
                </div>
              </div>
            </Fieldset>

            {/* Checkboxes adicionais */}
            <div className="grid mt-2">
              <div className="col-6">
                <SCCheckbox
                  control={control}
                  name="considerExpenses"
                  label="Não considerar as despesas com cartão de crédito/débito"
                />
              </div>
            </div>

            {/* Título */}
            <div className="grid mt-2">
              <div className="col-6">
                <SCInputText
                  control={control}
                  errors={errors}
                  label="Título"
                  name="title"
                  className="w-full"
                />
              </div>
            </div>

            {/* Classificado por */}
            <Fieldset
              legend="Classificado por"
              className="mt-2"
              style={{ border: "1px solid #ccc", borderRadius: "5px" }}
            >
              <div className="grid space-3">
                <div className="col-12 flex">
                  <SCRadioButton
                    control={control}
                    name="classifiedBy"
                    label="Data Pagto/Programação"
                    value="dataPagto"
                  />
                  <SCRadioButton
                    control={control}
                    name="classification"
                    label="Conta"
                    value="conta"
                  />
                </div>
              </div>
            </Fieldset>

            <Divider align="center" />
            <div className="flex flex-1 justify-content-end pt-1">
              <div style={{ display: "flex", flexDirection: "row" }}>
                <SCButton
                  tooltip="Exportar para Excel"
                  tooltipOptions={tooltipOptions}
                  className="p-button w-auto bg-green-400 border-green-400"
                  style={{ width: "50" }}
                  type="button"
                  onClick={() => onExcel()}
                >
                  <SiMicrosoftexcel size={20} color="white" />
                </SCButton>
                <SCButton
                  tooltip="Imprimir"
                  tooltipOptions={tooltipOptions}
                  type="submit"
                  className="p-button w-auto ml-3"
                  style={{
                    width: "50",
                    backgroundColor: "#0772B3",
                    borderColor: "#0772B3",
                  }}
                >
                  <SlPrinter size={20} color="white" />
                </SCButton>
              </div>
            </div>

            <SCDialog
              visible={reportData != null}
              style={{ width: "80vw", height: "90vh" }}
              onHide={() => setReportData(null)}
            >
              <iframe src={reportData} width="100%" height="100%"></iframe>
            </SCDialog>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default Relatorio_ContasAPagar;
